export type AppointmentStatus =
    | "PENDING"
    | "AWAITING_CONFIRMATION"
    | "CONFIRMED"
    | "CANCELLED"
    | "DECLINED"
    | "COMPLETED"
    | "NO_SHOW";

export const APPOINTMENT_STATUS_OPTIONS: { value: AppointmentStatus; label: string }[] = [
    { value: "PENDING", label: "Pending" },
    { value: "AWAITING_CONFIRMATION", label: "Awaiting confirmation" },
    { value: "CONFIRMED", label: "Confirmed" },
    { value: "CANCELLED", label: "Cancelled" },
    { value: "DECLINED", label: "Declined" },
    { value: "COMPLETED", label: "Completed" },
    { value: "NO_SHOW", label: "No-show" },
];

/** Statuses hidden from the calendar grid (still listed in the Appointments
 *  screen). A declined request never happened, so it doesn't belong on the grid. */
export const HIDDEN_FROM_CALENDAR: AppointmentStatus[] = ["DECLINED"];

/** Background color used in FullCalendar per status. */
export const STATUS_COLOR: Record<AppointmentStatus, string> = {
    // Pending is intentionally pale/washed-out so it reads as "not done yet".
    PENDING: "#fbe2b0",
    // Awaiting the client's confirmation of a waitlist-proposed slot — amber/attention.
    AWAITING_CONFIRMATION: "#f1b44c",
    CONFIRMED: "#34c38f",
    CANCELLED: "#a3a3a3",
    DECLINED: "#b96b6b",
    COMPLETED: "#50c5e0",
    NO_SHOW: "#f46a6a",
};
